// Shape post.media into a normalised array of { kind, uri, role, orientation? } items.
// Order is fixed: generated → video → original. Items without a uri are dropped.
//
// Accepts either:
//   - post.media: already-typed items (preferred when callers know the kinds)
//   - post.images: legacy string URLs in [generated, original] order, with an
//     optional sibling post.videoUrl that gets slotted between them
//   - post.imageTypes: optional roles aligned with post.images
export function resolvePostMedia(post) {
  if (!post) return [];

  if (Array.isArray(post.media)) {
    return post.media
      .filter((item) => item && item.uri)
      .map((item) => ({
        kind: item.kind === 'video' ? 'video' : 'image',
        uri: item.uri,
        role: item.role || (item.kind === 'video' ? 'video' : 'generated'),
        orientation: item.orientation,
      }));
  }

  const images = Array.isArray(post.images) ? post.images.filter(Boolean) : [];
  const imageTypes = Array.isArray(post.imageTypes) ? post.imageTypes : [];
  const inferRole = (index) => imageTypes[index] || (index === 0 ? 'generated' : 'original');

  const generated = images.length > 0 ?
    { kind: 'image', uri: images[0], role: inferRole(0) } :
    null;
  const original = images.length > 1 ?
    { kind: 'image', uri: images[1], role: inferRole(1) } :
    null;
  const video = post.videoUrl ?
    { kind: 'video', uri: post.videoUrl, role: 'video', orientation: post.videoOrientation } :
    null;

  return [generated, video, original].filter(Boolean);
}

// Convenience for building the typed media array on a page that already
// resolved its own URLs.
export function buildMediaItems({ generatedUrl, videoUrl, originalUrl, videoOrientation }) {
  return [
    generatedUrl ? { kind: 'image', uri: generatedUrl, role: 'generated' } : null,
    videoUrl ? { kind: 'video', uri: videoUrl, role: 'video', orientation: videoOrientation } : null,
    originalUrl ? { kind: 'image', uri: originalUrl, role: 'original' } : null,
  ].filter(Boolean);
}
